import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ClockFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12 21.45c5.22 0 9.45-4.23 9.45-9.45 0-5.22-4.23-9.45-9.45-9.45-5.22 0-9.45 4.23-9.45 9.45 0 5.22 4.23 9.45 9.45 9.45ZM11.33 6.6a.67.67 0 0 1 1.34 0v5.08l3.12 2.5c.29.23.34.66.1.95-.13.17-.33.25-.53.25-.15 0-.3-.05-.42-.15l-3.37-2.7a.674.674 0 0 1-.25-.53V6.6h.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ClockFilled
